import { Button } from '@mui/material';
import useModalTemplateStore from '../../hooks/useModalTemplateStore';

export default function CancelButton() {
  const close = useModalTemplateStore((state) => state.close);

  const handleCancelClick = () => {
    close();
  };

  return (
    <Button autoFocus variant="outlined" onClick={handleCancelClick}>
      Close
    </Button>
  );
}
